import { styled } from "@stitches/react";

const Nav = styled("nav", {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",

  ul: {
    padding: "1rem 0 0 0",
    listStyle: "none",
    display: "flex",
  },
  "ul li": {
    fontWeight: "500",
    fontSize: "1.1rem",
    cursor: "pointer",
  },
  "li a": {
    textDecoration: "none",
    color: "#000",
  },
  ".margin": {
    marginRight: "1.5rem",
  },
});

export function Header({ isLogged, logOut, reSync }) {
  return (
    <Nav>
      <ul>
        {isLogged && (
          <li onClick={reSync} className="margin">
            re-sync
          </li>
        )}
        {isLogged && <li onClick={logOut}>logout</li>}
      </ul>
      <ul>
        <li>
          {isLogged ? (
            <a
              href="https://chrome.google.com/webstore/detail/twitter-search/kicoaaaemngohpfklndinjafjeakdilb?hl=en&authuser=0"
              target="_blank"
              rel="noreferrer"
            >
              chrome extension
            </a>
          ) : (
            <a
              href="https://twitter.com/zehf/status/1420405501049942025"
              target="_blank"
              rel="noreferrer"
            >
              why a better search?
            </a>
          )}
        </li>
      </ul>
    </Nav>
  );
}
